module.exports = __WEBPACK_EXTERNAL_MODULE_74__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable"],"commonjs":"rxjs/add/observable/fromEvent","commonjs2":"rxjs/add/observable/fromEvent","amd":"rxjs/add/observable/fromEvent"}
// module id = 74
// module chunks = 0